import { ExtensionDefinition } from "@backstage/frontend-plugin-api";
import { EntityContentBlueprint } from "@backstage/plugin-catalog-react/alpha";
import { isJiraAvailable } from "@roadiehq/backstage-plugin-jira";

/**
 * Jira entity content tab.
 *
 * Renders the Jira overview card and the Jira activity stream in a dedicated
 * tab. Conditionally displayed via `isJiraAvailable`, which checks for the
 * Jira annotation on the entity.
 *
 * The loader uses a dynamic import of JiraTabContent.tsx to keep the Roadie
 * Jira bundle out of the main chunk -- it is only downloaded when the tab is
 * first opened (code splitting).
 */
export const jiraContent: ExtensionDefinition = EntityContentBlueprint.make({
    name: "jira",
    params: {
        path: "/jira",
        title: "Jira",
        filter: isJiraAvailable,
        loader: async () => {
            const { JiraTabContent } = await import("./JiraTabContent");
            return <JiraTabContent />;
        },
    },
});
